export default function(instance) {
  return {
    getHomes(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/homes/admin/", { params: data });
    },
    getAllHomes() {
      return instance.get("/api/homes/");
    },
    createNewHome(data) {
      return instance.post("/api/homes/admin/", {
        county_type: data.county_type,
        address: data.address,
        homestead_number: data.homestead_number
      });
    },
    addMeter(id, data) {
      return instance.post(`/api/homes/add_counter/${id}/`, {
        kind: data.kind,
        counter_number: data.counter_number
      });
    },
    deleteHome(idHome) {
      return instance.delete(`/api/homes/admin/${idHome}/`);
    },

    editHome(idHome, data) {
      return instance.put(`/api/homes/admin/${idHome}/`, data);
    }
  };
}
